const schema_unsubscribe = {
    type: {
        label: "Select Contact Type",
        placeholder: "Select Contact Type",
        type: "select",
        value: "",
        options: [{key: 'telephone', value: 'Telephone'}, {key: 'email', value: 'Email'}]
    },
    contact: {
        label: "Contact",
        placeholder: "Contact",
        type: "text",
        value: "",
    }
};
export default schema_unsubscribe;
